// Top-anchored WeTook W mark shown on post-loading state screens
// (SetupScreen, WaitingScreen, DeactivatedScreen, etc.). The loading
// flow keeps the same logo centered; once loading clears, the brand mark
// slides up to the header position so the state screen content sits in
// the visual center. Mirrors the top-aligned Image in BrandHeader on
// android/.../ui/MainActivity.kt.

export default function BrandHeader() {
  return (
    <div className="w-full flex justify-center pt-[clamp(1rem,5vh,2.5rem)]">
      {/* Rendered white (brightness-0 invert) so the hollow navy mark stays
          visible on the dark player state screens; transparent centre preserved. */}
      <img src="/frame-logo.avif" alt="Frame" className="h-[clamp(2.25rem,9vw,3.5rem)] w-auto brightness-0 invert" />
    </div>
  )
}
